import {useMemo} from 'react'
import {useGameStore} from '../../store/GameStoreContext'
import {CardEnum, CardStateUnordered} from '@colonist/game-states'
import {useMechanicValidatorDevelopmentCard} from '../../store/selectors/useMechanicValidatorDevelopmentCard'
import {useMechanicValidatorProgressCards} from '../../store/selectors/useMechanicValidatorProgressCards'

export const useBankCardState = () => {
    const resourceCards = useGameStore((state) => state.gameState.bankState.resourceCards)
    const developmentCards = useMechanicValidatorDevelopmentCard()
    const progressCards = useMechanicValidatorProgressCards()

    return useMemo<CardStateUnordered>(() => {
        const result: CardStateUnordered = {...resourceCards}
        if(developmentCards) {
            result[CardEnum.DevelopmentBack] = developmentCards.getTotalDevelopmentCardsInBank()
        }

        if(progressCards) {
            result[CardEnum.ProgressCardBack] = progressCards.bankProgressCards.getNumberOfCardsInInventory()
        }

        return result
    }, [resourceCards, developmentCards, progressCards])
}
